import request from "@/plugin/axios";

export function QyWxAccountLogin(data) {
  return request({
    url: "/QyWxAccountLogin",
    method: "post",
    data: data
  });
}

export function AccountLogin(data) {
  return request({
    url: "/AccountLogin",
    method: "post",
    data: data
  });
}

export function GetAuthKeys(data) {
  return request({
    url: "/GetAuthKeys",
    method: "post",
    data: data
  });
}

export function GetMenuTreeOnAuth(data) {
  return request({
    url: "/GetMenuTreeOnAuth",
    method: "post",
    data: data
  });
}
